import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	qrCodeContainer: {
		border       : `3px solid ${ theme.other.colors.border.primary }`,
		borderRadius : "10px"
	},
	popOverContainer: {
		display      : "flex",
		alignItems   : "center",
		padding      : "3.6rem 2.4rem 2.4rem 2.4rem",
		boxShadow    : "0 4px 6px 0 rgba(0, 0, 0, 0.2)",
		border       : theme.other.darkMode ? "none" : `1px solid ${ theme.other.colors.border.primary }`,
		borderRadius : "10px",
		gap          : "2.4rem"
	},
	buttonStyles: {
		height          : "unset",
		width           : "100%",
		padding         : "1rem 2rem",
		backgroundColor : theme.other.colors.secondaryBtn.default.background,
		border          : "none",
		borderRadius    : "10px",
		transition      : "all 0.05s ease",
		"&:hover"       : {
			backgroundColor: theme.other.colors.secondaryBtn.hover.background

		}
	},
	buttonContainer: {
		display       : "flex",
		flexDirection : "column",
		gap           : "1rem"
	},
	QRCodeParent: {
		display       : "flex",
		flexDirection : "column",
		alignItems    : "center"
	},
	scanText: {
		fontSize   : "1.2rem",
		lineHeight : "2.5rem"
	},
	iconStyles: {
		width       : "2.5rem",
		marginRight : "5px"
	},
	popperStyle: {
	},
	qrImage: {
		width        : "150px",
		height       : "150px",
		borderRadius : "10px"
	},
	btnText: {
		color: theme.other.colors.secondaryBtn.default.text
	}
} ) );
